export default class OnAction {
	constructor(dealerId, dealerName) {
		this._dealerId = dealerId
		this._dealerName = dealerName
		this._previosData = null
	}

	public send(object): void {
		const headers = {
			'Content-Type': 'application/json',
		}
		object.dealerId = this._dealerId
		object.dealerName = this._dealerName
		if (typeof object.actionData === 'object' && !object.actionData.location) {
			object.actionData.location = window.location.href
		}
		let data = JSON.stringify(object)
		if (data !== this._previosData) {
			fetch('/api/v1/onAction', {
				headers,
				method: 'POST',
				body: data,
			})
			this._previosData = data
		}
	}
}